import React from "react";

import { Config } from "../../../../shared/core/config/config";
import { configurationManager } from "../../../../shared/core/service/services";
import { useObservable } from "../../../../shared/utils/observable";
import { ArticlePage } from "../../common/article-page";

export const DeleteData = () => {
  const configuration = useObservable(configurationManager.configuration);
  const contactMail = configuration.contactEmail;
  const appName = Config.APP_NAME;

  return (
    <ArticlePage
      mainTitle={`Delete your data on ${appName}`}
      intro={`This page explains how to request deletion of your personal data collected via the ${appName} app.`}
      sections={[
        {
          title: "Steps to Request Data Deletion",
          content: (
            <ol className="list">
              <li className="list__item">
                Email us at <a href={`mailto:${contactMail}`}>{contactMail}</a>
              </li>
              <li className="list__item">
                Use the subject line: <strong>Request to Delete Personal Data</strong>
              </li>
              <li className="list__item">Include the email associated with your account and identity confirmation</li>
            </ol>
          ),
        },
        {
          title: "What Data Will Be Deleted?",
          content: (
            <ul className="list">
              <li className="list__item">Location and usage data</li>
              <li className="list__item">Device identifiers</li>
              <li className="list__item">Transaction history and saved settings</li>
            </ul>
          ),
        },
        {
          title: "Data We May Retain",
          content: (
            <p>
              Some financial data or identifiers may be retained where required by local regulations or for fraud
              prevention.
            </p>
          ),
        },
        {
          title: "Processing Time",
          content: (
            <p>
              Your request will be processed within <strong>5–7 business days</strong>.
            </p>
          ),
        },
        {
          title: "Need Help?",
          content: (
            <p>
              Contact us anytime at <a href={`mailto:${contactMail}`}>{contactMail}</a>
            </p>
          ),
        },
      ]}
    />
  );
};
